// getters
const getters = {
  getLanguage: (state) => state.language,
  getHomepageBanner: (state) => state.homepageBanner,
  getHomeFeature: (state) => state.homepageFeature,
  getHomeTestimoni: (state) => state.homepageTestimoni,
  getHomePartner: (state) => state.homepagePartner,
};

export default getters;
